// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__33qMH","title":"BackImages_title__YtaPi","images":"BackImages_images__1G8cK"};